<!-- STEPPER CONFIGURATION -->
@if (datasetACS.datasetConfig.stepViewConfig) {
  @switch (datasetACS.datasetCode) {
    <!-- TRIP PACKAGES -->
    @case ("trip_packages") {
      @switch (datasetACS.getValueFromKeyPath("domainTpl")) {
        @case (1) {
          <simp-temp-view-container
            [stepViewConfig]='stepViewConfig'
          ></simp-temp-view-container>
        }
        @default {
          <common-step-view-container
            [stepViewConfig]='datasetACS.datasetConfig.stepViewConfig'
          ></common-step-view-container>
        }
      }
    }
    <!-- PRODUCTS -->
    @case ("products") {
      <simp-temp-view-container
        [stepViewConfig]='productStepViewConfig'
      ></simp-temp-view-container>
    }
    <!-- DEFAULT -->
    @default {
      <common-step-view-container
        [stepViewConfig]='datasetACS.datasetConfig.stepViewConfig'
      ></common-step-view-container>
    }
  }
}
<!-- NORMAL CONFIGURATION -->
@if (!datasetACS.datasetConfig.stepViewConfig) {
  @switch (datasetACS.datasetConfig.name) {
    @default {
      <div class="fx-row fx-justify-start fx-items-center fx-xs-column">
        @if (datasetACS.datasetConfig) {
          <mat-card class='p-24'>
            @if (showHeader) {
              <mat-card-header>
                @if (!formConfig || !formConfig.title) {
                  <mat-card-title>Crea nuovo {{datasetACS.datasetConfig.singleTitle | translate | titlecase}}</mat-card-title>
                }
                @if (formConfig && formConfig.title) {
                  <mat-card-title>{{formConfig.title}}</mat-card-title>
                }
              </mat-card-header>
            }
            <mat-card-content>
              @if (datasetACS.loading.value) {
                <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
              }
              @if (formConfig && !datasetACS.loading.value) {
                <div class='mb-24'>
                  <form-viewer #formViewer [dataContainerService]='datasetACS' [formConfig]='formConfig'></form-viewer>
                </div>
              }
            </mat-card-content>
            <mat-card-actions>
              <button mat-flat-button [disabled]='datasetACS.loading.value' color='accent' (click)="onSave()">{{'Invia' | translate}}</button>
            </mat-card-actions>
          </mat-card>
        }
      </div>
    }
  }
}